import { useEffect, useState } from 'react';
export function useDebounce(value, delayMs = 350) {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const t = setTimeout(() => setDebounced(value), delayMs);
        return () => clearTimeout(t);
    }, [value, delayMs]);
    return debounced;
}
//# sourceMappingURL=use-debounce.js.map